export const WORK_CATEGORIES = [
  {
    key: "documentary",
    index: "01",
    title: "Film & Doc",
    copy: "Original scores and sonic identity for cinema and documentary.",
  },
  {
    key: "commercial",
    index: "02",
    title: "Branded Content",
    copy: "Music and sound design for campaigns, brands and moving images.",
  },
  {
    key: "press",
    index: "03",
    title: "Press",
    copy: "Features, interviews and editorial moments from the archive.",
  },
  {
    key: "lunatik",
    index: "04",
    title: "Lunatik",
    copy: "Live sets, endorsements and the electronic side of the practice.",
  },
];

export function workPath(category, id) {
  return `/works/${encodeURIComponent(category)}/${encodeURIComponent(
    String(id)
  )}`;
}

export function workHref(item) {
  const raw = item?.link ?? item?.Link;
  if (typeof raw !== "string") return "";
  const href = raw.trim();
  if (!href || !/^https?:\/\//i.test(href)) return "";
  return href;
}

export function isShownOnLanding(item) {
  const value = item?.ImageIsScoresHome ?? item?.image_is_scores_home;
  if (value == null || value === "") return true;
  return value !== false && String(value).toLowerCase() !== "false";
}

export function landingStripItems(list) {
  return (Array.isArray(list) ? list : []).filter(isShownOnLanding);
}

export function categoryPreviewItems(list, limit = 3) {
  const items = (Array.isArray(list) ? list : []).filter(
    (item) => item?.ImageUrl || item?.image_url
  );
  return landingStripItems(items).slice(0, limit);
}

export function categoryMeta(key) {
  return (
    WORK_CATEGORIES.find((item) => item.key === key) || {
      key,
      index: "",
      title: key,
      copy: "",
    }
  );
}
